function componentsRepositionCategory() {
  if ($("#filters").length) {
    repositionSideFilterAccordion();
    repositionFiltersContent();
    dropdownProductSorting();
  }
  if ($('.category-perex').length) {
    topDescriptionShowLessMoreText();

  }
  addPaginationScroll();
  if ($(".subcategories .parametric").length) {
    removeCategoryNameFromParametricSubcategory();

    document.addEventListener("ShoptetDOMPageContentLoaded", function () {
      removeCategoryNameFromParametricSubcategory();
    });
  }
  // it is necessary to edit sector furniture category directly in shoptet
  // add this element - <div id="wil-kolekcie-design">&nbsp;</div> to top category description of category
  sectorFurnitureSubcategories();

  // hide default image in subcategories if image does not exist
  hideDefaultImageSubcategory();

  // hide category 'other mattresses'
  hideOtherMattressesCategory();

  // change flag 'Viac farieb' to 'Viac rozmerov' - only for mattresses
  dimensionFlagInCategory();

  // hide flag 'Výpredaj' in sales category
  // hideFlagSaleInSaleCategory();

  if ($('#productsTop').length) {
    repositionProductFromUrlParams();
    fixToggleButtonLessMoreProducts();
  }

  similarCategories();
}

function addPaginationScroll() {
  if ($(".pagination-top").length) {
    if ($(".pagination-top .pagination-inner").length == 0) {
      $(".pagination-top").wrapInner("<div class='pagination-inner'></div>");
    }
    $(".pagination-top .pagination-inner").addClass("js-scroll-top");
  }
}

function repositionFilterSections() {
  $("#filters #category-filter-hover .filter-section input").each(function () {
    var inst = $(this);
    if (inst.prop("checked") === true) {
      inst.closest(".filter-section").addClass("is-active");
    }
  });
  if ($(window).width() < 768 || $(".mobile").length) {
    if (!isFilterChanged && $("#filters.visible").length) {
      $(".filters-unveil-button-wrapper a").trigger("click");
    }
  }
}

function repositionSideFilterAccordion() {
  $("body").on("click", ".filter-section h4", function () {
    $(this).closest(".filter-section").toggleClass(classIsActive);
  });

  $("body").on("click", ".slider-wrapper h4", function () {
    $(this).closest(".slider-wrapper").toggleClass(classIsActive);
  });

  $(".slider-wrapper").addClass(classIsActive);
  $(".toggle-filters").trigger("click");
}

function repositionFiltersContent() {
  $(".slider-wrapper").addClass(classIsActive);
  // if ($(window).width() > 768 || $(".mobile").length) {
  $(".toggle-filters").trigger("click");
  // $('#filters .filter-section-parametric input').each(function(){
  // 	var inst = $(this);
  // 	if (inst.prop('checked') === true){
  // 		inst.closest('').addClass('');
  // 	}
  // });
}

function hideDefaultImageSubcategory() {
  const $categories = $('.subcategories.with-image li');

  if ($categories.length === 0) return;

  const hasDefaultImage = $categories.find('.image img').filter(function () {
    const src = $(this).attr('src') || '';
    const dataSrc = $(this).attr('data-src') || '';
    return src.includes('folder.svg') || dataSrc.includes('folder.svg');
  }).length > 0;

  if (hasDefaultImage) {
    $categories.find('.image').hide();
  }

  $categories.show();
}

// remove category name from parametric subcategories names
function removeCategoryNameFromParametricSubcategory() {
  var replaceArray;
  switch (lang) {
    case 'sk':
      replaceArray = [
        'Matrace Materasso',
        'Penové matrace',
        'Taštičkové matrace',
        'Matrace s pamäťovou penou',
        'Kokosové matrace',
        'Pružinové matrace',
        'Latexové matrace',
        'Bio matrace',
        'Matrace 1+1',
        'Ortopedické matrace',
        'Lamelové rošty',
        'Latkové rošty',
        'Matrace - výška',
        'Vysoké matrace',
        'Matrace podľa nosnosti -',
        'Matrace podľa nosnosti',
        'Matrace Aloe Vera',
        'Molitanové matrace',
        'Matrace do ohrádky',
        'Vrchné matrace',
        'Podložky na matrac',
        'Chrániče na matrac',
        'Mäkké matrace',
        'Tvrdé matrace',
        'Zdravotné matrace',
        'Lacné matrace',
        'Antidekubitné matrace',
        'Tenké matrace',
      ];
      break;
    case 'hu':
      replaceArray = [
        'Materasso',
        'Habmatracok',
        'Táskarugós matracok',
        'Memóriahabos matracok',
        'Kókuszmatracok',
        'Rugós matracok',
        'Latex matracok',
        'Biohab matracok',
        '1 + 1 akciós matracok',
        'Ortopéd matracok',
        'Léces ágyrácsok',
        'Lamellás ágyrácsok',
        'Vastag matracok',
        'Matracok teherbírás szerint -',
        'Matracok teherbírás szerint',
        'Aloe Vera matracok',
        'Molitán matracok',
        'Matracok a járókába a',
        'Fedőmatracok',
        'Matracvédők',
        'Puha matracok',
        'Kemény matracok',
        'Egészségügyi matracok',
        'Olcsó matracok',
        'Felfekvés elleni matracok',
        'Vékony matracok',
      ];
      break;
    case 'cs':
      replaceArray = [
        'Matrace Materasso',
        'Pěnové matrace',
        'Taštičkové matrace',
        'Matrace s paměťovou pěnou',
        'Kokosové matrace',
        'Pružinové matrace',
        'Latexové matrace',
        'Bio matrace',
        'Matrace 1+1',
        'Ortopedické matrace',
        'Lamelové rošty',
        'Laťkové rošty',
        'Matrace - výška',
        'Vysoké matrace',
        'Matrace podle nosnosti –',
        'Matrace podle nosnosti',
        'Matrace Aloe Vera',
        'Molitanové matrace',
        'Matrace do ohrádky',
        'Vrchní matrace',
        'Podložky na matraci',
        'Chrániče na matraci',
        'Měkké matrace',
        'Tvrdé matrace',
        'Zdravotní matrace',
        'Levné matrace',
        'Antidekubitní matrace',
        'Tenké matrace',
      ];
      break;
    case 'ro':
      replaceArray = [
        'Saltele Materasso',
        'Saltele - înălţime ',
        'Saltele înalte',
        'Saltele subțiri',
        'În funcție de capacitatea de încărcare a saltelei -',
        'Saltele în funcție de capacitatea de greutate',
        'Saltea Aloe Vera',
        'Saltele din molitan',
        'Saltele Cocos',
        'Saltele pentru țarc',
        'Saltea de top',
        'Suporturi pentru saltele',
        'Protecții pentru saltele',
        'Saltele moi',
        'Saltele dure ',
        'Saltea duritate',
        'Saltele medicinale',
        'Topper saltele',
        'Saltele ieftine',
        'Saltele din spumă HR',
        'Saltele cu arcuri pocket',
        'Saltele din spumă cu memorie',
        'Saltele din spumă',
        'Saltele fibra de cocos',
        'Saltele cu arcuri',
        'Saltele latex',
        'Saltele Bio',
        'Saltele 1 + 1',
        'Saltele ortopedice',
        'Somieră cu lamele',
        'Somieră cu șipci',
        'Biospumă',
      ];
      break;
    case 'bg':
      replaceArray = [
        'Matrace Materasso',
        'Penové matrace',
        'Taštičkové matrace',
        'Matrace s pamäťovou penou',
        'Kokosové matrace',
        'Pružinové matrace',
        'Latexové matrace',
        'Bio matrace',
        'Matrace 1+1',
        'Ortopedické matrace',
        'Lamelové rošty',
        'Latkové rošty',
        'Matrace - výška',
        'Vysoké matrace',
        'Matrace podľa nosnosti -',
        'Matrace Aloe Vera',
        'Molitanové matrace',
        'Matrace do ohrádky',
        'Vrchné matrace',
        'Podložky na matrac',
        'Chrániče na matrac',
        'Mäkké matrace',
        'Tvrdé matrace',
        'Zdravotné matrace',
        'Lacné matrace',
        'Antidekubitné matrace',
        'Tenké matrace',
      ];
      break;
    case 'hr':
      replaceArray = [
        'Madraci Materasso',
        'Pjenasti madraci',
        'Džepni madraci',
        'Madraci od memorijske pjene',
        'Kokosovi madraci',
        'Opružni madraci',
        'Latex madraci',
        'Madraci 1+1',
        'Ortopedski madraci',
        'Lamelni okviri',
        'Okviri s letvicama',
        'Madraci - visina',
        'Visoki madraci',
        'Madraci prema nosivosti',
        'Madrac Aloe Vera',
        'Madraci od pjene',
        'Madrac za ogradicu',
        'Nadmadraci',
        'Podloge za madrac',
        'Zaštite za madrace',
        'Mekani madraci',
        'Cvrsti madraci',
        'Zdravstveni madraci',
        'Jeftini madraci',
        'Antidekubitalni madraci',
        'Tanki madraci',
        'Madraci od pjene',
      ];
      break;
    case 'sl':
      replaceArray = [
        'Vzmetnice z nosilnostjo',
        'Vzmetnice Materasso',
        'Pene vzmetnice',
        'Žepkaste vzmetnice',
        'Vzmetnice s spominsko peno',
        'Kokosove vzmetnice',
        'Vzmetne vzmetnice',
        'Lateksne vzmetnice',
        'Vzmetnice 1+1',
        'Ortopedske vzmetnice',
        'Lamelne rešetke z nosilnostjo',
        'Lamelne rešetke',
        'Lesene letvice',
        'Vzmetnice - višina',
        'Visoke vzmetnice',
        'Vzmetnice glede na nosilnost -',
        'Vzmetnice z nosilnostjo',
        'Vzmetnice Aloe Vera',
        'Vzmetnice za ograjo',
        'Zgornje vzmetnice',
        'Podloge za vzmetnico',
        'Zaščita za vzmetnico',
        'Mehke vzmetnice',
        'Trde vzmetnice',
        'Zdravstvene vzmetnice',
        'Poceni vzmetnice',
        'Antidekubitusne vzmetnice',
        'Tanke vzmetnice',
        'Vzmetnice iz PUR pene',
      ];
      break;
    case 'uk':
      replaceArray = [
        'Matrace Materasso',
        'Penové matrace',
        'Taštičkové matrace',
        'Matrace s pamäťovou penou',
        'Kokosové matrace',
        'Pružinové matrace',
        'Latexové matrace',
        'Bio matrace',
        'Matrace 1+1',
        'Ortopedické matrace',
        'Lamelové rošty',
        'Latkové rošty',
        'Matrace - výška',
        'Vysoké matrace',
        'Matrace podľa nosnosti -',
        'Matrace Aloe Vera',
        'Molitanové matrace',
        'Matrace do ohrádky',
        'Vrchné matrace',
        'Podložky na matrac',
        'Chrániče na matrac',
        'Mäkké matrace',
        'Tvrdé matrace',
        'Zdravotné matrace',
        'Lacné matrace',
        'Antidekubitné matrace',
        'Tenké matrace',
      ];
      break;
    default:
      return;
  }

  for (let i = 0; i < replaceArray.length; i++) {
    $('.subcategories.with-image .parametric .text:contains("' + replaceArray[i] + ' ' + '")').each(function () {
      $(this).html($(this).html().replace(replaceArray[i] + ' ', ''));
    });
  }
}

function sectorFurnitureSubcategories() {
  if ($('#wil-kolekcie-design').length) {
    $('ul.subcategories.with-image').addClass('w-kolekcie');
    if ($('.category-perex.empty-content.empty-content-category').length) {
      $('.category-perex.empty-content.empty-content-category').hide();
    }
  }
}

function hideFilterBadges() {
  // zoznam príznakov
  const hiddenLabels = [
    "Vyrobené na SK"
  ];

  document.querySelectorAll('.box-filters .filter-section-boolean .filter-label').forEach(label => {
    hiddenLabels.forEach(text => {
      if (label.textContent.includes(text)) {
        const wrapper = label.closest('div'); // skryjeme celé div
        if (wrapper) wrapper.style.display = 'none';
      }
    });
  });
}

function repositionProductFromUrlParams() {
  const queryString = window.location.search;
  if (queryString.length > 0) {
    const urlParams = new URLSearchParams(queryString);
    const productId = urlParams.get('apid');
    const productUrl = urlParams.get('apurl');
    const productImg = urlParams.get('apimg');
    const productName = urlParams.get('aptitle');
    const productPrice = urlParams.get('apprice');
    const productText = urlParams.get('aptext');
    if (productId && productId.length && productUrl && productUrl.length && productImg && productImg.length && productName && productName.length && productPrice && productPrice.length) {
      //try to find product on product list
      if ($('#products .product .p[data-micro-product-id="' + productId + '"]').length) {
        let existingProduct = $('#products .product .p[data-micro-product-id="' + productId + '"]').closest('.product');
        $('#products').prepend(existingProduct);
      } else {
        //if it does not exist, create new one at first position
        let showMoreText = productText;
        let button = '';
        let html = '<div class="product"><div class="p"><a href="' + productUrl + '" class="image"><img src="' + productImg + '"></a><div class="p-in"><div class="p-in-in"><a href="' + productUrl + '" class="name"><span>' + productName + '</span></a><div class="ratings-wrapper"><div class="availability"><span style="color:#1C7D1D">' + showMoreText + '</span></div></div></div><div class="p-bottom single-button no-buttons"><div><div class="prices"><div class="price price-final"><strong>' + productPrice + '</strong></div></div><div class="p-tools">' + button + '</div></div></div></div></div></div>';
        $('#products').prepend(html);
      }
    }
  }
}

function mattressSpecialDescriptionCategory() {
  var pageTypeControll = dataLayer[0].shoptet.pageType;
  var specificPageTypes = ['category', 'parametricCategory'];
  var urlContainsTerm = ['matrac', 'biopena', 'saltea', 'saltele'];

  if (
    urlContainsTerm.some(function (term) {
      return window.location.href.indexOf(term) > -1;
    }) &&
    specificPageTypes.some(function (specificPageType) {
      return pageTypeControll.includes(specificPageType);
    })
  ) {
    $('.p-desc').addClass('mattress-special-description-wrap').show();
  }
}

function fixToggleButtonLessMoreProducts() {
  var products = document.querySelectorAll('#productsTop .product');
  if (window.innerWidth <= bpLarge && products.length >= 3) {
    products[2].classList.remove('active');
    products[2].classList.add('inactive');
  }
}

function dropdownProductSorting() {
  if (window.innerWidth <= bpLarge) {
    var productSortingTerm = '';
    switch (lang) {
      case 'sk':
        productSortingTerm = 'Zoradiť';
        break;
      case 'hu':
        productSortingTerm = 'Rendezés';
        break;
      case 'cs':
        productSortingTerm = 'Seřadit';
        break;
      case 'ro':
        productSortingTerm = 'Sortează';
        break;
      case 'bg':
        productSortingTerm = 'Zoradiť';
        break;
      case 'hr':
        productSortingTerm = 'Poredaj';
        break;
      case 'sl':
        productSortingTerm = 'Razvrstiti';
        break;
      case 'uk':
        productSortingTerm = 'Zoradiť';
        break;
      default:
        return;
    }

    // Dropdown menu
    $('#category-header').children().wrapAll('<div class="dropdown"></div>');
    var dropdownButton = $('<a class="toggle-sorting">' + productSortingTerm + '</a>');
    var dropdownProductCount = $('.dropdown > div').wrap('<div class="dropdown-content product-count"></div>');
    var dropdownContent = $('#category-header form').wrap('<div class="dropdown-content"></div>');
    var productSortingForm = $('#category-header form');

    $('#category-header .dropdown').prepend(dropdownButton);

    // Button text based on the checked input
    var checkedInput = productSortingForm.find('input[type="radio"]:checked');
    if (checkedInput.length > 0) {
      // For order1 - default value
      if (checkedInput.attr('id') === 'order1') {
        dropdownButton.text(productSortingTerm);
        // Others - value from label
      } else {
        dropdownButton.text(checkedInput.next('label').text());
      }
    }
    dropdownButton.click(function () {
      $('.dropdown-content').toggleClass('active-dropdown-content');
      dropdownButton.toggleClass('active-dropdown-button');
    });
  }
}

function topDescriptionShowLessMoreText() {
  var btnShowMoreTerm;
  var btnShowLessTerm;
  switch (lang) {
    case 'sk':
      btnShowMoreTerm = 'Zobraziť viac';
      btnShowLessTerm = 'Zobraziť menej';
      break;
    case 'hu':
      btnShowMoreTerm = 'Továbbiak megjelenítése';
      btnShowLessTerm = 'Kevesebb megjelenítése';
      break;
    case 'cs':
      btnShowMoreTerm = 'Zobrazit více';
      btnShowLessTerm = 'Zobrazit méně';
      break;
    case 'ro':
      btnShowMoreTerm = 'Afișați mai multe';
      btnShowLessTerm = 'Afișați mai puțin';
      break;
    case 'bg':
      btnShowMoreTerm = 'Zobraziť viac';
      btnShowLessTerm = 'Zobraziť menej';
      break;
    case 'hr':
      btnShowMoreTerm = 'Prikaži više';
      btnShowLessTerm = 'Prikaži manje';
      break;
    case 'sl':
      btnShowMoreTerm = 'Prikazati več';
      btnShowLessTerm = 'Prikazati manj';
      break;
    case 'uk':
      btnShowMoreTerm = 'Zobraziť viac';
      btnShowLessTerm = 'Zobraziť menej';
      break;
    default:
      return;
  }
  var isExpanded = false;
  // Do not apply to empty category-perex
  var categoryPerex = $('#content .category-perex').not('.empty-content, .empty-content-category');
  // Do not apply to categories that are collections or collection podcategories
  if ($('#wil-kolekcie-design').length || $('.category-perex img').length) {
    return;
  }
  var heightCategoryPerex = $('.category-perex').outerHeight();

  // Show toggleBtn only if the category-perex has a height greater than max-height to avoid displaying the button if text of category is shorter
  if (heightCategoryPerex > 104) {
    var toggleBtn = $('<div class="toggle-btn">' + btnShowMoreTerm + '</div>');
    categoryPerex.after(toggleBtn);

    // Toggle content and button text
    toggleBtn.click(function () {
      if (isExpanded) {
        categoryPerex.removeClass('top-description-expanded');
        toggleBtn.removeClass('top-description-expanded').text(btnShowMoreTerm);
      } else {
        categoryPerex.addClass('top-description-expanded');
        toggleBtn.addClass('top-description-expanded').text(btnShowLessTerm);
      }
      isExpanded = !isExpanded;
    });
  }
}

//Use full term for free shipping
function freeDeliveryInCategory() {
  var flagText;

  if (lang === 'sk') {
    flagText = "Doprava zadarmo";
  } else if (lang === 'hu') {
    flagText = "Ingyenes szállítással";
  } else {
    return;
  }

  $('.product .flags.flags-extra .flag-freeshipping').each(function () {
    var flagFreeShipping = $(this);
    if (flagFreeShipping.length) {
      flagFreeShipping.find(".flag-text").text(flagText);
    }
  });

  if (lang === 'hu' || lang === 'sk' && $(window).width() < bpXsmall) {
    $('.product .flags.flags-extra .flag-freeshipping').addClass('hide-freeshipping-icon');
  }
}

function dimensionFlagInCategory() {
  var multipleDimensionsTerm;
  var multipleColorsFilterTerm;
  var pDescMultipleDimensionsTerm;
  var breadcrumbsCategoryTerm;
  var mattressTopperTerm;
  var mattressTopperTerm2;

  switch (lang) {
    case 'sk':
      multipleDimensionsTerm = 'Viac rozmerov';
      multipleColorsFilterTerm = 'Viac farieb';
      pDescMultipleDimensionsTerm = 'tvrdosť';
      breadcrumbsCategoryTerm = 'matrace';
      mattressTopperTerm = 'vrchný matrac';
      break;
    case 'hu':
      multipleDimensionsTerm = 'Több méretben';
      multipleColorsFilterTerm = 'Több színben';
      pDescMultipleDimensionsTerm = 'keménység:';
      breadcrumbsCategoryTerm = 'matracok';
      mattressTopperTerm = 'fedőmatrac';
      break;
    case 'cs':
      multipleDimensionsTerm = 'Více rozměrů';
      multipleColorsFilterTerm = 'Více barev';
      pDescMultipleDimensionsTerm = 'tvrdost:';
      breadcrumbsCategoryTerm = 'matrace';
      mattressTopperTerm = 'vrchní matrac';
      break;
    case 'ro':
      multipleDimensionsTerm = 'Mai multe dimensiuni';
      multipleColorsFilterTerm = 'Mai multe culori';
      pDescMultipleDimensionsTerm = 'duritate:';
      breadcrumbsCategoryTerm = 'saltele';
      mattressTopperTerm = 'saltea superioară';
      break;
    case 'bg':
      multipleDimensionsTerm = 'Viac rozmerov';
      multipleColorsFilterTerm = 'Viac farieb';
      pDescMultipleDimensionsTerm = 'tvrdosť';
      breadcrumbsCategoryTerm = 'matrace';
      mattressTopperTerm = 'vrchný matrac';
      break;
    case 'hr':
      multipleDimensionsTerm = 'Više dimenzija';
      multipleColorsFilterTerm = 'Više boja';
      pDescMultipleDimensionsTerm = 'tvrdoća';
      breadcrumbsCategoryTerm = 'madrac';
      mattressTopperTerm = 'gornji madrac';
      mattressTopperTerm2 = 'nadmadrac';
      break;
    case 'sl':
      multipleDimensionsTerm = 'Več dimenzij';
      multipleColorsFilterTerm = 'Več barv';
      pDescMultipleDimensionsTerm = 'trdota';
      breadcrumbsCategoryTerm = 'vzmetnice';
      mattressTopperTerm = 'zgornja';
      break;
    case 'uk':
      multipleDimensionsTerm = 'Viac rozmerov';
      multipleColorsFilterTerm = 'Viac farieb';
      pDescMultipleDimensionsTerm = 'tvrdosť';
      breadcrumbsCategoryTerm = 'matrace';
      mattressTopperTerm = 'vrchný matrac';
      break;
    default:
      return;
  }

  $('.product .flag.flag-viac_farieb').each(function () {
    var flagMultipleDimensions = $(this).closest('.product'); // Get the closest product element
    var productDescText = flagMultipleDimensions.find('.p-desc').text().toLowerCase();
    var productDescClass = flagMultipleDimensions.find('.p-desc');
    var productNameText = flagMultipleDimensions.find('.name').text().toLowerCase();

    // Check if the product description contains the word "hardness:" or has the class "mattress-special-description-wrapp"
    if (
      (productDescText.includes(pDescMultipleDimensionsTerm) ||
        productDescClass.hasClass('mattress-special-description-wrapp')) ||
      productNameText.includes(mattressTopperTerm.toLowerCase()) ||
      (mattressTopperTerm2 && productNameText.includes(mattressTopperTerm2.toLowerCase()))
    ) {
      flagMultipleDimensions.find('.flag.flag-viac_farieb').text(multipleDimensionsTerm).addClass('flag-multiple-dimensions');
    }
  });


  // Fix display in filters - only for mattress categories / mattress sale categories
  if ($('#navigation-1 span').text().toLowerCase().includes(breadcrumbsCategoryTerm) || $('#navigation-2 span').text().toLowerCase().includes(breadcrumbsCategoryTerm)) {
    $('.param-filter-top fieldset label').each(function () {
      var label = $(this);
      var labelText = label.contents().filter(function () {
        return this.nodeType === 3;
      }).text().trim();

      if (labelText === multipleColorsFilterTerm) {
        label.contents().filter(function () {
          return this.nodeType === 3;
        })
        [0].nodeValue = multipleColorsFilterTerm + ' / ' + multipleDimensionsTerm;
      }
    });
  }
}

function hideOtherMattressesCategory() {
  var categoryTextToHide;
  var inMattressCategory = $('.in-matrace');

  switch (lang) {
    case 'sk':
      categoryTextToHide = 'Matrace ostatné';
      break;
    case 'hu':
      categoryTextToHide = 'Egyéb matracok';
      inMattressCategory = $('.in-matracok');
      break;
    case 'cs':
      categoryTextToHide = 'Matrace ostatní';
      break;
    case 'ro':
      categoryTextToHide = 'Alte saltele';
      inMattressCategory = $('.in-saltele');
      break;
    case 'bg':
      categoryTextToHide = 'Matrace ostatné';
      break;
    case 'hr':
      categoryTextToHide = 'Madraci ostalo';
      break;
    case 'sl':
      categoryTextToHide = 'Druge vzmetnice';
      break;
    case 'uk':
      categoryTextToHide = 'Matrace ostatné';
      break;
    default:
      return;
  }

  // Hide the "Services" category everywhere
  $('.subcategories.with-image li').each(function () {
    if ($(this).find('a .text').text().trim() === 'Služby') {
      $(this).hide();
      return false;
    }
  });

  // Hide "Other mattresses" only in the mattresses category
  if (inMattressCategory.length) {
    $('.subcategories.with-image li').each(function () {
      if ($(this).find('a .text').text().trim() === categoryTextToHide) {
        $(this).hide();
        return false;
      }
    });
  }
}

function hideFlagSaleInSaleCategory() {
  const navSpan = $('#navigation-1 span[itemprop="name"]');
  var navigationSaleTerm;
  switch (shopName) {
    case 'wsk':
      navigationSaleTerm = 'VÝPREDAJ';
      break;
    case 'whu':
      navigationSaleTerm = 'KIÁRUSÍTÁS';
      break;
    case 'wcz':
      navigationSaleTerm = 'Výprodej';
      break;
    case 'wro':
      navigationSaleTerm = 'Vânzâri finale';
      break;
    case 'wbg':
      navigationSaleTerm = 'VÝPREDAJ';
      break;
    case 'whr':
      navigationSaleTerm = 'RASPRODAJA';
      break;
    case 'wsi':
      navigationSaleTerm = 'RAZPRODAJA';
      break;
    case 'wua':
      navigationSaleTerm = 'VÝPREDAJ';
      break;
    default:
      return;
  }

  if (navSpan.length > 0 && navSpan.text().trim() === navigationSaleTerm) {
    $('.product .flag.flag-vypredaj').hide();
  }
}

function similarCategories() {
  var btnShowMoreTerm, btnShowLessTerm;

  switch (lang) {
    case 'sk': btnShowMoreTerm = 'Zobraziť viac'; btnShowLessTerm = 'Zobraziť menej'; break;
    case 'hu': btnShowMoreTerm = 'Továbbiak megjelenítése'; btnShowLessTerm = 'Kevesebb megjelenítése'; break;
    case 'cs': btnShowMoreTerm = 'Zobrazit více'; btnShowLessTerm = 'Zobrazit méně'; break;
    case 'ro': btnShowMoreTerm = 'Afișați mai multe'; btnShowLessTerm = 'Afișați mai puțin'; break;
    case 'bg': btnShowMoreTerm = 'Zobraziť viac'; btnShowLessTerm = 'Zobraziť menej'; break;
    case 'hr': btnShowMoreTerm = 'Prikaži više'; btnShowLessTerm = 'Prikaži manje'; break;
    case 'sl': btnShowMoreTerm = 'Prikazati več'; btnShowLessTerm = 'Prikazati manj'; break;
    case 'uk': btnShowMoreTerm = 'Zobraziť viac'; btnShowLessTerm = 'Zobraziť menej'; break;
    default: return;
  }

  document.querySelectorAll('.type-category').forEach((product, i) => {
    const custom = product.querySelector('.custom-related-categories');
    if (!custom) return;


    // wrapper
    let content = custom.querySelector('.custom-description-content');
    if (!content) {
      content = document.createElement('div');
      content.className = 'custom-description-content';
      while (custom.firstChild) content.appendChild(custom.firstChild);
      custom.appendChild(content);
    }

    const contentId = content.id || `custom-desc-${i}`;
    content.id = contentId;

    const shouldHaveToggle = custom.querySelectorAll('li').length > 9;

    // ak netreba toggle tak nič
    if (!shouldHaveToggle) {
      custom.classList.remove('open');
      const oldBtn = custom.querySelector('.toggle-more-btn');
      if (oldBtn) oldBtn.remove();
      return;
    }

    // button
    let btn = custom.querySelector('.toggle-more-btn');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'toggle-more-btn';
      custom.appendChild(btn);

      btn.addEventListener('click', () => {
        const isOpen = custom.classList.toggle('open');
        btn.textContent = isOpen ? btnShowLessTerm : btnShowMoreTerm;
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    // init a sync
    const isOpen = custom.classList.contains('open');
    btn.textContent = isOpen ? btnShowLessTerm : btnShowMoreTerm;
    btn.setAttribute('aria-controls', contentId);
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}
